export default {"src":"/_next/static/media/instagram.0196433f.svg","height":132,"width":132,"blurWidth":0,"blurHeight":0};